export const CONSTANTS = {
  EMPTY_STRING: "",
};
